import React from 'react';
import { PrimaryColor } from 'styles/Global/colorSemantic';

const IcLnbReady = ({ $active }: { $active?: boolean }) => {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M9.4 12.0008C9.4 12.6635 8.86274 13.2008 8.2 13.2008C7.53726 13.2008 7 12.6635 7 12.0008C7 11.338 7.53726 10.8008 8.2 10.8008C8.86274 10.8008 9.4 11.338 9.4 12.0008Z'
                fill={$active ? PrimaryColor.color_primary_normal : '#333438'}
            />
            <path
                d='M13.1998 12.0008C13.1998 12.6635 12.6625 13.2008 11.9998 13.2008C11.3371 13.2008 10.7998 12.6635 10.7998 12.0008C10.7998 11.338 11.3371 10.8008 11.9998 10.8008C12.6625 10.8008 13.1998 11.338 13.1998 12.0008Z'
                fill={$active ? PrimaryColor.color_primary_normal : '#333438'}
            />
            <path
                d='M16.9996 12.0008C16.9996 12.6635 16.4624 13.2008 15.7996 13.2008C15.1369 13.2008 14.5996 12.6635 14.5996 12.0008C14.5996 11.338 15.1369 10.8008 15.7996 10.8008C16.4624 10.8008 16.9996 11.338 16.9996 12.0008Z'
                fill={$active ? PrimaryColor.color_primary_normal : '#333438'}
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M19 5H5L5 19H19V5ZM5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5Z'
                fill={$active ? PrimaryColor.color_primary_normal : '#333438'}
            />
        </svg>
    );
};

export default IcLnbReady;
